/**
 * Platform detection utilities for PWA and iOS-specific logic.
 */

export const isIOSDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  if (/iphone|ipad|ipod/i.test(navigator.userAgent)) return true;
  // iPadOS 13+ reports as MacIntel but exposes touch points
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
};

export const isStandalonePWA = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true
  );
};

/** iOS Safari — excludes Chrome/Firefox/Edge for iOS which also support push differently */
export const isIOSSafari = (): boolean => {
  if (!isIOSDevice()) return false;
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
};

/**
 * Returns true on iOS when the app is NOT installed as a PWA.
 * Push notifications on iOS require the app to be opened from the home screen.
 */
export const needsIOSInstall = (): boolean => isIOSDevice() && !isStandalonePWA();
